import styled from "styled-components";
import {
  BACKGROUND_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { FONT_SIZE } from "../../../constants/design/fontSize";
import { SPACING } from "../../../constants/design/spacing";

export const DropdownTitle = styled.div`
  font-size: ${FONT_SIZE.one};
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    margin-right: ${SPACING.one}px;
  }
`;

export const DropdownItem = styled.div<{ isSelected?: boolean }>`
  padding: ${SPACING.two}px;
  font-size: ${FONT_SIZE.one};
  color: ${({ isSelected }) =>
    isSelected ? TEXT_COLORS.one : TEXT_COLORS.three};
  background-color: ${BACKGROUND_COLORS.four};

  &:hover {
    color: ${TEXT_COLORS.one};
  }

  > span:first-child {
    margin-right: ${SPACING.three}px;
  }

  display: flex;
  align-items: center;
`;

export const X = styled.span`
  padding-left: ${SPACING.one}px;
  padding-right: ${SPACING.two}px;
  color: ${TEXT_COLORS.three};
  font-size: ${FONT_SIZE.one};
`;
